import request from '@/utils/request.js'


/**
 * @description: 查询所有智库
 */
export function getOrganList() {
	return request({
		url: '/newzealand/api/organ/getOrganList',
		method: 'post',
	})
}



/**
 * 查询智库机构左侧数据源
 * @returns 
 */
export const selectAllSource = () => {
	return request({
		url: '/newzealand/api/organ/allSource',
		method: 'get'
	})
}

/**
 * 点击左侧数据源查询单个
 * @returns 
 */
export const selectIntroductoryById = (id) => {
	return request({
		url: '/newzealand/api/organ/selectIntroductory',
		method: 'get',
		params: {
			id
		}
	})
}

/**
 * 根据智库id分页查询人员
 * @returns 
 */
export const pageOrgan = (params) => {
	return request({
		url: '/newzealand/api/organ/OrganPage',
		method: 'post',
		data: params
	})
}

/**
 * 根据智库id分页查询涉hua人员
 * @returns 
 */
export const pageHuaOrgan = (params) => {
	return request({
		url: '/newzealand/api/organ/OrganHuaPage',
		method: 'post',
		data: params
	})
}

/**
 * 根据智库id查询涉hua小组人员
 * @returns 
 */
export const getPeopleList = (id) => {
	return request({
		url: '/newzealand/api/organ/getPeopleList',
		method: 'get',
		params: {
			id
		}
	})
}

/**
* @description: 首页官网推荐
*/
export function selectAllOrgan() {
	return request({
		url: '/newzealand/api/organ/getFiveOrgan',
		method: 'get'
	})
}


/*综合检索智库列表 */
export function zhSearchOrganPage(params) {
	return request({
		url: '/newzealand/api/organ/getOrganPage',
		method: 'post',
		data: params
	})
}





// WEBPACK FOOTER //
// ./src/api/organization.js